
import {getContrastYIQ} from "./colors";
import {updateGraphs} from "./eleccions/graphs";

const state = {
    historicalData: [],
    year: 2023,
    regidorsChart: undefined,
    votesChart: undefined,
    historicRegidorsChart: undefined,
    historicVotsChart: undefined,
    colors: undefined,
    zones: undefined,
    vots: undefined,
    escrutat: 0,
    lastUpdated: '-',
    regidors: undefined,
    selected: 'total'
}

function setSelected(selected) {
    state.selected = selected;
    updateRenders(state)
}

function vots(dades) {
    var data = [];

    var i = 0;
    for (var v in dades.vots) {
        data[i] = {label : v, data: dades.vots[v], color: resultats.colors[v]}
        i++;
    }

    mostra_plot(data,label_vots);

    return false;
}

function downloadAndRender(year) {
    downloadVotes(year)
        .then(s => updateRenders(state))
}

function downloadVotes(year) {
    return fetch(`${globalData.theme_url}/data/eleccions${year}.json?t=${Date.now()}`)
        .then(d => d.json())
        .then(d => fillState(year, d))
}

function downloadHistorical(year) {
    return fetch(`${globalData.theme_url}/data/eleccions${year}.json?t=${Date.now()}`)
        .then(d => d.json())
        .then(d => fillHistorical(year, d))
}

function fillState(year, data) {
    state.year = year
    state.colors = data.colors
    state.zones = data.zones
    state.partits = data.partits
    state.escrutat = data.escrutat
    state.vots = data.vots

    state.lastUpdated = (new Date()).toLocaleString('ca-ES', {
        timeStyle: "medium",
        dateStyle: "medium",
    })
}

function fillHistorical(year, data) {
    state.historicalData[year] = data
}

function updateRenders(state) {
    hideInexistantMeses(state)
    updateGraphs(state);
    renderColors(state)
    updateTimestamp(state)
}

function updateTimestamp(state) {
    const u = document.getElementById('eleccions-update');
    if (u) {
        u.innerHTML = state.lastUpdated
    }
}

function renderColors(state) {
    const legend = document.getElementsByClassName('legend')[0]

    const html = Object.keys(state.colors).map(k => `
<div class="column has-text-centered is-uppercase has-text-weight-semibold" style="background: ${state.colors[k]}; color: ${getContrastYIQ(state.colors[k])}">${k}</div>
`
    );
    legend.innerHTML = `<div class="columns is-centered"><div class="column is-1"></div>${html.join('')}<div class="column is-1"></div></div>`
}

const TWO_MINUTES = 2 * 60 * 1000

function configureVotes() {
    if ( document.getElementById('eleccions-regidors-graph') != null) {

        [2007, 2011, 2015, 2019, 2023].map(y => downloadHistorical(y))

        const params = new URLSearchParams(document.location.search);

        const year = params.has('debugYear') ? params.get('debugYear') : document.getElementById('eleccions-regidors-graph').dataset.year
        if (year) {

            // setInterval(() => downloadAndRender(year), TWO_MINUTES);
            downloadAndRender(year);

            const buttons = document.getElementsByClassName('eleccions-button');

            for (const button of buttons) {
                button.onclick = function () {
                    setSelected(this.dataset.eleccionsCalc)
                }
            }

            if (document.getElementById('update-info') != null) {
                const now = new Date()

                const params = new URLSearchParams(document.location.search);

                if ((now.getDate() === 28 && now.getMonth() === 4 && now.getFullYear() === 2023 && now.getHours() >= 20)
                    || params.has('debug')) {

                    const info = document.getElementById('update-info');

                    if (info) {
                        info.classList.remove('is-hidden');
                    }

                    const button = document.getElementById('update-data');
                    if (button) {
                        button.onclick = () => downloadAndRender(year)
                    }
                }

                if (params.has('debug')) {
                    document.getElementById('button-block').classList.remove('is-hidden');
                }
            }

            const regLink = document.getElementById('regidors-tab-link')
            const votLink = document.getElementById('vots-tab-link')
            const historicLink = document.getElementById('historic-tab-link')
            const regTab = document.getElementById('regidors-tab')
            const votTab = document.getElementById('vots-tab')
            const historicTab = document.getElementById('historic-tab')
            if (regLink && votLink) {
                regLink.onclick = function() {
                    if(!regTab.classList.contains('is-active')) {
                        regTab.classList.add('is-active')
                        votTab.classList.remove('is-active')
                        historicTab.classList.remove('is-active')

                        showAllButtons()
                        updateGraphs(state)
                    }
                }

                votLink.onclick = function() {
                    if(!votTab.classList.contains('is-active')) {
                        votTab.classList.add('is-active')
                        regTab.classList.remove('is-active')
                        historicTab.classList.remove('is-active')

                        showAllButtons()
                        updateGraphs(state)
                    }
                }

                historicLink.onclick = function() {
                    if(!historicTab.classList.contains('is-active')) {
                        historicTab.classList.add('is-active')
                        regTab.classList.remove('is-active')
                        votTab.classList.remove('is-active')

                        hideMesesButtons()
                        updateGraphs(state)
                    }
                }
            }
        }
    }
}

function showAllButtons() {
    const buttons = document.getElementsByClassName('eleccions-button')

    for (const button of buttons) {
        button.classList.remove('is-invisible')
    }
}

function hideMesesButtons() {

    const buttons = document.getElementsByClassName('eleccions-button')

    for (const button of buttons) {
        const data = button.dataset.eleccionsCalc;

        if ( data.split('-').length === 3) {
            if (!button.classList.contains('is-invisible')) {
                button.classList.add('is-invisible')
            }
        }
    }
}

function hideInexistantMeses(state) {

    const buttons = document.getElementsByClassName('eleccions-button')

    for (const button of buttons) {
        const data = button.dataset.eleccionsCalc;

        if (data.split('-').length === 3 && !state.vots[data]) {
            if (!button.classList.contains('is-hidden')) {
                button.classList.add('is-hidden')
            }
        } else {
            button.classList.remove('is-hidden')
        }
    }
}


configureVotes()